import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Global/Buttons/Button';

const SpellCheck = ({ originalQuery, correctedQuery, spellcheckEnabled, onEnableSpellcheckClick, onOriginalQuerySearchClick }) => {
  const spellCheckClass = `spellcheck m-b-5`;
  let spellCheck;
  {/* TODO: Re-implement this? Display originalQuery and optional spell check; Did you mean 'correctedQuery'? */}
  if (spellcheckEnabled === false) {
    spellCheck = (
      <div className={spellCheckClass}>
        <h2 className="m-b-0">Showing results for <strong>{`${originalQuery}`}</strong></h2>
        {/* <Button classes="link" onClick={onEnableSpellcheckClick} faux>Enable spellcheck?</Button> */}
      </div>
    );
  // spellchecking disabled, give option to re enable
  {/* } else if (spellcheckEnabled !== undefined && originalQuery !== correctedQuery) {    // if spellcheck has occurred
    spellCheck = (
      <div className={spellCheckClass}>
        <h2 className="m-b-0">Showing results for {`${correctedQuery}`}</h2>
        <div>
          Search instead for&nbsp;
          <Button classes="link" onClick={onOriginalQuerySearchClick} faux>
            <strong>{`${originalQuery}`}</strong>
          </Button>
        </div>
      </div>
    ); */}
  } else {
    spellCheck = null;
  }
  return spellCheck;
};

SpellCheck.propTypes = {
  originalQuery: PropTypes.string.isRequired,
  correctedQuery: PropTypes.string,
  spellcheckEnabled: PropTypes.bool.isRequired,
  onEnableSpellcheckClick: PropTypes.func.isRequired,
  onOriginalQuerySearchClick: PropTypes.func.isRequired,
};

export default SpellCheck;



// WEBPACK FOOTER //
// ./library/app/components/Search/SpellCheck.js